import { PDFViewer } from '@react-pdf/renderer';
import Certificate from '../helper/Certificate';
import { useLocation, useHistory } from 'react-router';
import { useEffect, useState } from 'react';
import axios from 'axios';
import PageHeader from "../helper/PageHeader";

import NoDataFound from "../helper/NoDataFound";

function DownloadUserCertificate(){
    const location = useLocation()

    const [data, setData ]= useState({
        FirstName: '',
        MiddleName: '',
        LastName: '',
        Suffix: '',
        Trainee_ID: '',
        CertDate: '',
        Instructor: '',
        score: '',
        CompanyName: ''
    })
    const [disablePDF, setDisablePDF] = useState(false);
    const history = useHistory()


    useEffect(()=>{
        console.log('cert ID', location.state.certID)
        if(location.state.certID){
            
            axios.get('/api/certificate/'+ location.state.certID, {})
            .then((res)=> {
                console.log('res', res)
                setData(res.data.certificate)
            }).catch(error => {
                setDisablePDF(true)
            });
        }
        
    }, [location.state.certID])

    return (
        <div>
            <PageHeader
                title={'GI-BMP Certificate'} 
                cancel={history.goBack}
            /> 

            {
                disablePDF ? 
                <NoDataFound message="This certificate cannot be downloaded. It may have been replaced by a more recent certification. Please contact the GI-BMP office for help." /> 
                :
                <>

                <PDFViewer width="100%" height="1000px">
                <Certificate 
                    certID= {location.state.certID || ''} 
                    certDate = {data.CertDate || ''}
                    name = {data.FirstName + ' '+( data.MiddleName ? data.MiddleName : '') + ' ' + data.LastName + (data.Suffix ? ', ' + data.Suffix: '' ) }
                    traineeID = {data.Trainee_ID}
                    instructor ={data.Instructor}
                    testScore = {data.score}
                    companyName = {data.CompanyName}
                    />
                 </PDFViewer>
                 </>
            }

        </div>
        
        
    )
}

export default DownloadUserCertificate